import script from "./Joins.vue?vue&type=script&setup=true&lang=js"
export * from "./Joins.vue?vue&type=script&setup=true&lang=js"

import "./Joins.vue?vue&type=style&index=0&id=0d58fb44&lang=css"

const __exports__ = script;

export default __exports__